var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DraggableGoalItem from '@/views/Groups/Tabs/GoalPlanner/DraggableGoalItem/DraggableGoalItem.vue';
import dragula from 'dragula';
import 'dragula/dist/dragula.css';
import { Group } from '@/models/Group';
let ExpandableGoalItem = class ExpandableGoalItem extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isOpen = {};
        this.drake = null;
        this.hasTriggeredSubjectStatusCount = false;
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    created() {
        this.loadOpenStateFromStore();
    }
    mounted() {
        this.initialize();
    }
    async initialize() {
        // Clean up any previous instance
        this.destroyDrake();
        // Only initialize for child nodes with visible content
        if (!this.isChild || !this.hasVisibleChildrenOrSubjects)
            return;
        const { sourceContainer, calendarEventNodes } = this.getDragSources();
        if (!sourceContainer || !calendarEventNodes || calendarEventNodes.length === 0)
            return;
        const drake = dragula([sourceContainer, ...calendarEventNodes], {
            copy: (el, source) => source === sourceContainer,
            revertOnSpill: true,
            removeOnSpill: false,
        });
        this.drake = drake;
        this.bindDragEvents(drake, sourceContainer, calendarEventNodes);
    }
    destroyDrake() {
        if (this.drake) {
            this.drake.destroy();
            this.drake = null;
        }
    }
    beforeDestroy() {
        if (this.drake) {
            this.drake.destroy();
            this.drake = null;
        }
    }
    removeGuTransitFromContainer(container) {
        container.querySelectorAll('.gu-transit').forEach((node) => node.classList.remove('gu-transit'));
    }
    applyGuTransitToSelected(container) {
        const selectedItemIds = this.$store.state.selectedGroupSubjectIds;
        selectedItemIds.forEach((id) => {
            const node = container.querySelector(`[data-group-subject-id="${id}"]`);
            const card = node?.closest('.draggable-goal-item__container') || node;
            if (card)
                card.classList.add('gu-transit');
        });
    }
    // #endregion
    // #region Event handlers
    onChildEmit(payload) {
        if (!this.isChild) {
            this.$emit('subject:dropped', payload);
        }
    }
    onTriggerSubjectStatusCount() {
        if (this.hasTriggeredSubjectStatusCount) {
            return; // Prevent multiple triggers
        }
        this.hasTriggeredSubjectStatusCount = true;
    }
    isSelected(id) {
        const ids = this.$store.state.selectedGroupSubjectIds;
        return ids.includes(id);
    }
    onToggleSelected(id) {
        const index = this.$store.state.selectedGroupSubjectIds.indexOf(id);
        if (index > -1) {
            this.$store.dispatch('removeSelectedGroupSubjectId', id);
        }
        else {
            this.$store.dispatch('addSelectedGroupSubjectId', id);
        }
    }
    bindDragEvents(drake, sourceContainer, calendarEventNodes) {
        const removeGuTransitFromContainer = () => this.removeGuTransitFromContainer(sourceContainer);
        drake.on('drag', (element) => {
            const sourceCard = element.closest('.draggable-goal-item__container') || element;
            if (sourceCard)
                sourceCard.classList.add('gu-transit');
            this.applyGuTransitToSelected(sourceContainer);
        });
        drake.on('drop', (element, target, source, sibling) => {
            this.dropGoalHandler(element, target, source, sibling);
            removeGuTransitFromContainer();
        });
        drake.on('cancel', removeGuTransitFromContainer);
        drake.on('dragend', removeGuTransitFromContainer);
        drake.on('cloned', (mirror) => {
            mirror.classList.add('expandable-goal-item--dragging');
        });
    }
    // #endregion
    // #region Class methods
    getDragSources() {
        const sourceContainer = this.getSourceContainer();
        const calendarEventNodes = this.getCalendarEventNodes();
        return { sourceContainer, calendarEventNodes };
    }
    getSourceContainer() {
        return this.$refs.draggableList;
    }
    getCalendarEventNodes() {
        return Array.from(document.querySelectorAll('.calendar-event-droppable'));
    }
    dropGoalHandler(el, target, source, sibling) {
        if (target && target.classList.contains('calendar-event-droppable')) {
            const timeslotId = target.getAttribute('data-timeslot-id');
            const date = target.getAttribute('data-date');
            const selectedIds = this.$store.state.selectedGroupSubjectIds || [];
            let subjectIds = [];
            if (selectedIds.length > 1) {
                subjectIds = selectedIds
                    .map((groupSubjectId) => this.getSubjectIdFromGroupSubjectId(groupSubjectId))
                    .filter((subjectId) => !!subjectId);
            }
            else {
                const singleId = el.getAttribute('data-subject-id');
                if (singleId)
                    subjectIds = [singleId];
            }
            const payload = {
                subjects: subjectIds,
                timeslotId: timeslotId || '',
                date: date || '',
                source,
                target,
            };
            this.$emit('subject:dropped', payload);
            // clear the global selection after drop
            this.$store.dispatch('clearSelectedGroupSubjectIds');
        }
    }
    loadOpenStateFromStore() {
        const storedState = this.$store.state.expandableGoalItemsState[this.item.id];
        if (storedState) {
            Object.keys(storedState).forEach((itemId) => {
                if (this.itemExists(itemId)) {
                    this.isOpen[itemId] = storedState[itemId];
                }
            });
        }
    }
    saveOpenStateToStore() {
        if (Object.keys(this.isOpen).length > 0 &&
            Object.values(this.isOpen).some((value) => value === true)) {
            this.$store.dispatch('setExpandableGoalItemState', {
                itemId: this.item.id,
                openState: { ...this.isOpen },
            });
        }
        else {
            // Clear from store if no items are open
            this.$store.dispatch('setExpandableGoalItemState', {
                itemId: this.item.id,
                openState: {},
            });
        }
    }
    itemExists(itemId) {
        if (this.item.id === itemId)
            return true;
        if (Array.isArray(this.item.children)) {
            return this.item.children.some((child) => child.id === itemId);
        }
        return false;
    }
    find(data, key, value) {
        const indexes = [];
        const index = -1;
        const subjects = [];
        data.forEach((item, index) => {
            if (item.parent[key] === value) {
                indexes.push(index);
                subjects.push(this.subjects[index]);
            }
        });
        return subjects;
    }
    subjectsForTopic(topicId) {
        return this.find(this.subjects, 'id', topicId);
    }
    onToggleSelect(id, checked) {
        if (checked) {
            this.$store.dispatch('addSelectedGroupSubjectId', id);
        }
        else {
            this.$store.dispatch('removeSelectedGroupSubjectId', id);
        }
    }
    getSubjectIdFromGroupSubjectId(id) {
        const groupSubject = this.subjects.find((subject) => subject?.id === id);
        return groupSubject?.subject || null;
    }
    // #endregion
    // #region Async methods (api calls only)
    async reinitialize() {
        await this.initialize();
    }
    // #endregion
    // #region Getters & Setters
    get hasVisibleChildrenOrSubjects() {
        if (this.isChild) {
            return this.subjectsForTopic(this.item.id).length > 0;
        }
        if (Array.isArray(this.item.children)) {
            return this.item.children.some((child) => this.subjectsForTopic(child.id).length > 0);
        }
        return false;
    }
    get itemTotalCount() {
        let totalCount = 0;
        if (!this.isChild) {
            if (Array.isArray(this.item.children)) {
                totalCount = this.item.children.reduce((sum, child) => sum + this.subjectsForTopic(child.id).length, 0);
            }
        }
        else {
            totalCount = this.subjectsForTopic(this.item.id).length;
        }
        return totalCount;
    }
    // #endregion
    // #region @Watchers
    onIsOpenChange(newValue, oldValue) {
        this.saveOpenStateToStore();
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], ExpandableGoalItem.prototype, "group", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object)
], ExpandableGoalItem.prototype, "item", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Array)
], ExpandableGoalItem.prototype, "subjects", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], ExpandableGoalItem.prototype, "isChild", void 0);
__decorate([
    Watch('isOpen', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, Boolean]),
    __metadata("design:returntype", void 0)
], ExpandableGoalItem.prototype, "onIsOpenChange", null);
ExpandableGoalItem = __decorate([
    Component({
        name: 'expandable-goal-item',
        components: {
            DraggableGoalItem,
        },
    })
], ExpandableGoalItem);
export default ExpandableGoalItem;
// #endregion
// #region Constants
// #endregion
